export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M14.4 3.21a1 1 0 011.308.071l3.561 3.442a1 1 0 01-.006 1.445L9.188 17.725a1 1 0 01-.346.214l-.166.06H20v2H3a1.001 1.001 0 01-.94-1.341l2-5.5.046-.106a1 1 0 01.205-.278l10.013-9.5.075-.064zM5.857 14.063l-1.187 3.265 3.29-1.196 9.167-8.697-2.122-2.051-9.148 8.68z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};